import React from 'react';
import axios from 'axios';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import AutoResponsive from 'autoresponsive-react';
import FindURL from '../search/common/FindURL';
import config from '../../lib/config-api.json';
import TestImg from '../../assets/image/62-aec-2-aa-27665-aaf-6-a-51208393-dd-76-fa@2x.png';

import {
  CardImage,
  CardSource,
  CardTitle,
  GridLayoutContent,
  GridLayoutTitle,
  ImageContainCard,
  ImageNonCard,
  Textbox,
} from '../common/MainGridLayout';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

class PersonalRecommend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      smallRandomArray: this.setRandomValue(),
      bigRandomArray: this.setRandomValue(),
      innerWidth: window.innerWidth,
      styleBig: {
        width: 340,
        height: 378,
      },
      styleSmall: {
        width: 340,
        height: 180,
      },
    };
  }

  componentDidMount() {
    const mainGridLayoutElement = document.getElementById('mainGridLayout');
    if (mainGridLayoutElement) {
      this.setState({
        containerWidth: mainGridLayoutElement.clientWidth,
        innerWidth: window.innerWidth,
      });
      if (window.innerWidth < 1100) {
        this.setState({
          styleBig: {
            width: (mainGridLayoutElement.clientWidth - 32) / 2 - 10,
            height: 272,
          },
          styleSmall: {
            width: (mainGridLayoutElement.clientWidth - 32) / 2 - 10,
            height: 132,
          },
        });
      }
    }
  }

  onClickNormal = (id, targetId) => {
    const { onPostConsumption } = this.props;
    let targets = 'travel_info';
    switch (targetId) {
      case 0:
        targets = 'travel_info';
        break;
      case 1:
        targets = 'recommended_info';
        break;
      case 2:
        targets = 'course_info';
        break;
      default:
        break;
    }
    ReactGA.ga('send', 'event', `click_main_personal_contents(no-image)`);
    const data = {
      primary_key: id,
      target: targets,
      document_type: 'normal',
      session: localStorage.getItem('aivory_session_id') || 'test_session',
      reaction_type: 0,
      read_type: 1,
    };
    const newData = {
      primary_key: id,
      target: targets,
      document_type: 'normal',
      read_type: 1,
    };
    onPostConsumption(newData);
    axios({
      method: 'post',
      url: `${apiInfo.api_url}/read/`,
      timeout: 10000,
      data,
    });
  };

  onClickImage = (id, targetId) => {
    const { onPostConsumption } = this.props;
    let targets = 'travel_info';
    switch (targetId) {
      case 0:
        targets = 'travel_info';
        break;
      case 1:
        targets = 'recommended_info';
        break;
      case 2:
        targets = 'course_info';
        break;
      default:
        break;
    }
    ReactGA.ga('send', 'event', `click_main_personal_contents(image)`);
    const data = {
      primary_key: id,
      target: targets,
      document_type: 'image',
      session: localStorage.getItem('aivory_session_id') || 'test_session',
      reaction_type: 0,
      read_type: 1,
    };
    const newData = {
      primary_key: id,
      target: targets,
      document_type: 'image',
      read_type: 1,
    };
    onPostConsumption(newData);
    axios({
      method: 'post',
      url: `${apiInfo.api_url}/read/`,
      timeout: 10000,
      data,
    });
  };

  shouldComponentUpdate(nextProps, nextState) {
    const { totalRecommendData } = this.props;
    const { styleBig } = this.state;

    if (nextProps.totalRecommendData !== totalRecommendData) {
      return true;
    }
    if (nextState.styleBig !== styleBig) {
      return true;
    }
    return false;
  }

  setRandomValue = () => {
    const n = 10;
    const ar = [];
    let temp = 0;
    let rnum = 0;

    for (let index = 0; index < n; index += 1) {
      ar.push(index);
    }

    for (let index = 0; index < ar.length; index += 1) {
      rnum = Math.floor(Math.random() * n);
      temp = ar[index];
      ar[index] = ar[rnum];
      ar[rnum] = temp;
    }
    return ar;
  };

  makeReactNodeList = (result) => {
    const { styleBig, styleSmall } = this.state;
    const ReactNodeResult = [];

    result.forEach((element) => {
      let urlInfo = { url: '', source: '' };
      let targetId = 1;

      if (element.travel_info_id) {
        urlInfo = FindURL(element.cot_id, 0);
        targetId = 0;
      } else if (element.recommended_info_id) {
        urlInfo = FindURL(element.cot_id, 1);
        targetId = 1;
      } else if (element.course_info_id) {
        urlInfo = FindURL(element.cot_id, 2);
        targetId = 2;
      } else {
        urlInfo = FindURL(element.cot_id, 1);
        targetId = 1;
      }

      if (element.image) {
        const src = apiInfo.api_url_image;
        ReactNodeResult.push(
          <ImageContainCard
            key={element.id}
            className="vory1 item"
            style={styleBig}
            href={urlInfo.url}
            target="_blank"
            onClick={() => {
              this.onClickImage(element.id, targetId);
            }}
          >
            <CardImage imageSrc={`${src}${element.image}`} />
            <Textbox>
              <CardTitle>{element.title}</CardTitle>
              <CardSource>{urlInfo.source}</CardSource>
            </Textbox>
          </ImageContainCard>
        );
      } else {
        ReactNodeResult.push(
          <ImageNonCard
            key={element.id}
            className="vory2 item"
            style={styleSmall}
            href={urlInfo.url}
            target="_blank"
            onClick={() => {
              this.onClickNormal(element.id, targetId);
            }}
          >
            <Textbox>
              <CardTitle>{element.title}</CardTitle>
              <CardSource>{urlInfo.source}</CardSource>
            </Textbox>
          </ImageNonCard>
        );
      }
    });

    return ReactNodeResult;
  };

  shuffleRandomImageNonCard = (rowNumber, endCount) => {
    const { smallRandomArray } = this.state;
    const { totalRecommendData } = this.props;
    let startIndex = 0;
    let endIndex = endCount;
    const result = [];

    if (rowNumber === 1) {
      startIndex = 4;
      endIndex += startIndex;
    }

    if (totalRecommendData) {
      smallRandomArray.some((element, index) => {
        if (index > endIndex - 1) {
          return true;
        }
        if (index > startIndex - 1) {
          if (totalRecommendData.recommended_info) {
            totalRecommendData.recommended_info.results.some(
              (elementData, indexData) => {
                if (indexData === element) {
                  result.push(elementData);
                  return true;
                }
                return false;
              }
            );
          }
        }
        return false;
      });
    }

    return result;
  };

  shuffleRandomImageContainCard = (rowNumber, endCount) => {
    const { RecommendImageArray } = this.props;
    const { bigRandomArray } = this.state;

    let startIndex = 0;
    let endIndex = endCount;
    const result = [];

    if (rowNumber === 1) {
      startIndex = 3;
      endIndex += startIndex;
    }

    bigRandomArray.some((element, index) => {
      if (index > endIndex - 1) {
        return true;
      }
      if (index > startIndex - 1) {
        if (RecommendImageArray.length > 0) {
          RecommendImageArray.some((elementData, indexData) => {
            if (indexData === element) {
              result.push(elementData);
              return true;
            }
            return false;
          });
        }
      }
      return false;
    });

    return result;
  };

  makeCase1Grid = (rowNumber) => {
    const result = [];
    let ReactNodeResult = [];
    const case1Random = Math.floor(Math.random() * 3);
    switch (case1Random) {
      case 0: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 1);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 4);
        BigReuslts.forEach((element) => {
          result.push(element);
        });
        SmallResults.forEach((element) => {
          result.push(element);
        });

        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }

      case 1: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 1);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 4);

        SmallResults.forEach((element) => {
          result.push(element);
        });
        BigReuslts.forEach((element) => {
          result.splice(1, 0, element);
        });
        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }
      case 2: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 1);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 4);

        SmallResults.forEach((element) => {
          result.push(element);
        });
        BigReuslts.forEach((element) => {
          result.splice(2, 0, element);
        });
        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }
      default: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 1);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 4);

        SmallResults.forEach((element) => {
          result.push(element);
        });
        BigReuslts.forEach((element) => {
          result.splice(2, 0, element);
        });
        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }
    }
  };

  makeCase2Grid = (rowNumber) => {
    const result = [];
    let ReactNodeResult = [];
    const case2Random = Math.floor(Math.random() * 3);
    switch (case2Random) {
      case 0: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 2);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 2);
        BigReuslts.forEach((element) => {
          result.push(element);
        });
        SmallResults.forEach((element) => {
          result.push(element);
        });

        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }
      case 1: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 2);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 2);
        result.push(BigReuslts[0]);
        result.push(SmallResults[0]);
        result.push(BigReuslts[1]);
        result.push(SmallResults[1]);

        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }
      case 2: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 2);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 2);
        result.push(SmallResults[0]);
        result.push(BigReuslts[0]);
        result.push(BigReuslts[1]);
        result.push(SmallResults[1]);

        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }

      default: {
        const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 2);
        const SmallResults = this.shuffleRandomImageNonCard(rowNumber, 2);
        result.push(SmallResults[0]);
        result.push(BigReuslts[0]);
        result.push(BigReuslts[1]);
        result.push(SmallResults[1]);

        ReactNodeResult = this.makeReactNodeList(result);

        return ReactNodeResult;
      }
    }
  };

  makeCase0Grid = (rowNumber) => {
    let ReactNodeResult = [];
    const BigReuslts = this.shuffleRandomImageContainCard(rowNumber, 3);
    ReactNodeResult = this.makeReactNodeList(BigReuslts);
    return ReactNodeResult;
  };

  makeLessThan10Case = () => {
    const { totalRecommendData, RecommendImageArray } = this.props;
    const result = [];

    if (totalRecommendData && totalRecommendData.recommended_info) {
      totalRecommendData.recommended_info.results.some((element) => {
        if (result.length > 4) {
          return true;
        }
        result.push(element);
        return false;
      });
    }

    if (
      totalRecommendData &&
      totalRecommendData.recommended_info &&
      totalRecommendData.recommended_info.results.length > 6
    ) {
      if (RecommendImageArray.length > 0) {
        RecommendImageArray.some((element, index) => {
          if (index > 3) {
            return true;
          }
          result.splice(index + 2, 0, element);
          return false;
        });
      }
    } else if (result.length > 2) {
      if (RecommendImageArray.length > 0) {
        RecommendImageArray.some((element, index) => {
          if (index > 5) {
            return true;
          }
          result.splice(index + 1, 0, element);
          return false;
        });
      }
    } else if (RecommendImageArray.length > 0) {
      RecommendImageArray.some((element, index) => {
        if (index > 5) {
          return true;
        }
        result.push(element);
        return false;
      });
    }

    return this.makeReactNodeList(result);
  };

  makePersonal = (rowNumber) => {
    const { totalRecommendData, RecommendImageArray } = this.props;
    const caseRandom = Math.floor(Math.random() * 3);
    if (
      totalRecommendData &&
      totalRecommendData.recommended_info &&
      totalRecommendData.recommended_info.results.length > 9 &&
      RecommendImageArray.length > 9
    ) {
      switch (caseRandom) {
        case 0:
          return this.makeCase0Grid(rowNumber);

        case 1:
          return this.makeCase1Grid(rowNumber);

        case 2:
          return this.makeCase2Grid(rowNumber);

        default:
          return this.makeCase1Grid(rowNumber);
      }
    } else {
      if (rowNumber === 1) {
        return [];
      }

      return this.makeLessThan10Case();
    }
  };

  render() {
    const { totalRecommendData } = this.props;
    const { containerWidth, innerWidth } = this.state;
    return (
      <GridLayoutContent className="testpanel" id="mainGridLayout">
        {totalRecommendData && totalRecommendData.recommended_info ? (
          <>
            {totalRecommendData.travel_info ? null : (
              <GridLayoutTitle>나에게 꼭 맞는 추천</GridLayoutTitle>
            )}

            {innerWidth < 1100 ? (
              <AutoResponsive
                itemMargin={8}
                containerWidth={containerWidth - 32}
                // containerHeight= {400}
                itemClassName="item"
                gridWidth={2}
                transitionDuration=".5"
                closeAnimation
              >
                {this.makePersonal(0)}
                {this.makePersonal(1)}
              </AutoResponsive>
            ) : (
              <AutoResponsive
                itemMargin={18}
                containerWidth={1070}
                // containerHeight= {400}
                itemClassName="item"
                gridWidth={20}
                transitionDuration=".5"
              >
                {this.makePersonal(0)}
                {this.makePersonal(1)}
              </AutoResponsive>
            )}
          </>
        ) : null}
      </GridLayoutContent>
    );
  }
}

export default PersonalRecommend;

const ImageMeta = PropTypes.shape({
  size: PropTypes.arrayOf(PropTypes.number),
});
const TravelInfoImageResult = PropTypes.shape({
  content: PropTypes.string,
  cot_id: PropTypes.string,
  created: PropTypes.string,
  id: PropTypes.number,
  image: PropTypes.string,
  image_meta: PropTypes.oneOfType([ImageMeta, PropTypes.any]),
  is_thumbnail_exist: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]),
  score: PropTypes.number,
  title: PropTypes.string,
  travel_info_id: PropTypes.number,
  url: PropTypes.string,
});
const TravelInfoImage = PropTypes.shape({
  results: PropTypes.arrayOf(TravelInfoImageResult),
  total: PropTypes.number,
});
const Noun = PropTypes.shape({
  count: PropTypes.number,
  name: PropTypes.string,
});
const ExtractedTags = PropTypes.shape({
  nouns: PropTypes.arrayOf(Noun),
});
const TravelInfoResult = PropTypes.shape({
  address: PropTypes.string,
  business_time: PropTypes.string,
  con_type: PropTypes.string,
  content: PropTypes.string,
  cot_id: PropTypes.string,
  created: PropTypes.string,
  extracted_tags: ExtractedTags,
  id: PropTypes.number,
  inquiries: PropTypes.string,
  is_complete: PropTypes.number,
  location_depth_1: PropTypes.string,
  location_depth_2: PropTypes.string,
  menu: PropTypes.string,
  modified: PropTypes.string,
  mother: PropTypes.number,
  noun: PropTypes.string,
  parking: PropTypes.string,
  phone: PropTypes.string,
  price: PropTypes.string,
  reaction_1_count: PropTypes.oneOfType([PropTypes.number, PropTypes.any]),
  score: PropTypes.number,
  son: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
  website: PropTypes.string,
});
const TravelInfo = PropTypes.shape({
  results: PropTypes.arrayOf(TravelInfoResult),
  total: PropTypes.number,
});
const RecommendedInfoImageResult = PropTypes.shape({
  content: PropTypes.string,
  cot_id: PropTypes.string,
  created: PropTypes.string,
  id: PropTypes.number,
  image: PropTypes.string,
  recommended_info_id: PropTypes.number,
  score: PropTypes.number,
  title: PropTypes.string,
  url: PropTypes.string,
});
const RecommendedInfoImage = PropTypes.shape({
  results: PropTypes.arrayOf(RecommendedInfoImageResult),
  total: PropTypes.number,
});

const CourseInfoResult = PropTypes.shape({
  con_type: PropTypes.string,
  content: PropTypes.string,
  cot_id: PropTypes.string,
  created: PropTypes.string,
  extracted_tags: PropTypes.oneOfType([ExtractedTags, PropTypes.any]),
  id: PropTypes.number,
  is_complete: PropTypes.oneOfType([PropTypes.number, PropTypes.any]),
  length: PropTypes.oneOfType([PropTypes.any, PropTypes.string]),
  location_depth_1: PropTypes.string,
  location_depth_2: PropTypes.string,
  modified: PropTypes.string,
  mother: PropTypes.number,
  noun: PropTypes.string,
  score: PropTypes.number,
  son: PropTypes.number,
  tags: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
});
const ContentsInfo = PropTypes.shape({
  results: PropTypes.arrayOf(CourseInfoResult),
  total: PropTypes.number,
});
const Payload = PropTypes.shape({
  course_info: ContentsInfo,
  recommended_info: ContentsInfo,
  recommended_info_image: RecommendedInfoImage,
  travel_info: TravelInfo,
  travel_info_image: TravelInfoImage,
});

PersonalRecommend.defaultProps = {
  totalRecommendData: null,
  RecommendImageArray: [],
  onPostConsumption: () => {
    const a = 1;
  },
};

PersonalRecommend.propTypes = {
  RecommendImageArray: PropTypes.arrayOf(RecommendedInfoImageResult),
  totalRecommendData: Payload,
  onPostConsumption: PropTypes.func,
};
